const STATS = [
  { value: '3.2万+', label: '高清影片资源' },
  { value: '每日更新', label: '最新片源同步' },
  { value: '零缓冲', label: 'CDN极速分发' },
];

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, oklch(0.70 0.18 82) 0%, transparent 50%), radial-gradient(circle at 75% 30%, oklch(0.60 0.17 25) 0%, transparent 40%)',
        }}
      />

      <div className="w-full px-4 md:px-6 py-16 md:py-20 max-w-[1440px] mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span className="whitespace-nowrap">全网热映中</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              花生影院
              <span className="block text-primary-600 mt-1 text-2xl sm:text-3xl md:text-4xl">
                你的私人电影大全
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-5 max-w-xl mx-auto lg:mx-0">
              全新一代在线观影平台，打造极致观影体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              花生影院汇聚海量电影大全资源，涵盖动作、喜剧、科幻、悬疑、爱情等全类型影片。每日同步更新最新电影资源，支持高清免费在线观看，采用多线CDN加速技术确保流畅不缓冲。无论你是想重温经典老片，还是追逐最新院线大片，花生影院电影排行榜都能帮你快速找到心仪好片。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-accent-600">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-trophy-line mr-2"></i>
                查看热门榜单
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3 border border-secondary-300 text-foreground-700 font-medium rounded-lg hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-compass-3-line mr-2"></i>
                探索精选专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-100/60 rounded-3xl rotate-3" />
              <div className="absolute -inset-4 bg-accent-100/40 rounded-3xl -rotate-2" />
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-secondary-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20interior%20with%20golden%20velvet%20curtains%20and%20film%20projector%20beam%2C%20art%20deco%20architectural%20details%2C%20soft%20dramatic%20lighting%2C%20elegant%20warm%20gold%20and%20amber%20tones%2C%20vintage%20cinema%20aesthetic%2C%20no%20people%2C%20atmospheric%20composition&width=800&height=600&seq=hero-movie-2026-01&orientation=landscape"
                  alt="花生影院在线观影平台主视觉"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}